module.exports = __webpack_public_path__ + "static/media/icon_location_history.0df4da15.svg";